import { useIntl } from "react-intl";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { NavBarConst } from "../../../constants/NavBarConst";
import { createContext, useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { toAbsoluteUrl } from "../../../utils/CommonHelper";
import { FaStar } from "react-icons/fa6";
import { CgCloseO } from "react-icons/cg";
import { PromotionReviewModal } from "./PromotionReview";
import { useAuth } from "../../auth/components/AuthInit";

const MasterLayoutContext = createContext();

export const MasterLayout = () => {
  const intl = useIntl();
  const { auth } = useAuth();
  const location = useLocation();
  const path = location.pathname;
  const [isVisible, setIsVisible] = useState(true);
  const masterLayoutState = useSelector(
    ({ masterLayout }) => masterLayout,
    shallowEqual
  );
  const { promoShow, setPromoShow } = useAuth();
  const navigate = useNavigate();
  const ipaddress = localStorage.getItem("ipaddress");
  const language = localStorage.getItem("locale");
  const platform = sessionStorage.getItem("platform");
  const value = {};

  const checkIsGame =
    path.includes("/slot") ||
    path.includes("/live") ||
    path.includes("/app") ||
    path.includes("/fishing") ||
    path.includes("/sport") ||
    path.includes("/lottery");

  const checkIsSetting =
    path.includes("/profile") ||
    path.includes("/personal") ||
    path.includes("/pointShop") ||
    path.includes("/bonus") ||
    path.includes("/withdraw") ||
    path.includes("/deposit") ||
    path.includes("/memberTransfer") ||
    path.includes("/addbank");

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };
  const toggleDownload = () => {
    if (sessionStorage.getItem("platform") === "mobile") {
      navigate("/setting/download");
    } else {
      window.open("/setting/download");
    }
  };
  useEffect(() => {
    const isMobile = sessionStorage.getItem("platform") === "mobile";
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    if (isMobile || isSafari) {
      document.querySelector(".bottom-download").style.display = "none";

      return () => {
        document.querySelector(".bottom-download").style.display = "flex";
      };
    }
  });

  useEffect(() => {
    if (sessionStorage.getItem("platform") === "mobile") {
      console.log(`memberid: ${auth.memberid}`);
    }
  }, []);
  // useEffect(() => {
  //   if (platform !== "telegram" && !promoShow) {
  //     const modalTrigger = document.getElementById("modalTrigger");
  //     if (modalTrigger) {
  //       modalTrigger.click();
  //     }
  //     setPromoShow(true);
  //   } else {
  //     setPromoShow(false);
  //   }
  // }, []);
  const imageUrl = toAbsoluteUrl("/image/logo.avif?123914128");
  return (
    <>
      <MasterLayoutContext.Provider value={value}>
        <div
          className="bottom-navbar"
          style={{
            position: "fixed",
            bottom: 0,
            width: "100%",
            height: "7vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "black",
            background: "black",
            zIndex: 999,
          }}
        >
          {Object.entries(NavBarConst).map(([key, value]) => (
            <div
              key={key}
              className={`cursor-pointer pb-2 ${
                checkIsSetting
                  ? value === NavBarConst.profile
                    ? "active"
                    : ""
                  : checkIsGame
                  ? value === NavBarConst.home
                    ? "active"
                    : ""
                  : path === `/setting${value}` || path === `${value}`
                  ? "active"
                  : ""
              }`}
              onClick={() => {
                navigate(path === value ? `${value}` : `/setting${value}`);
              }}
              style={{
                display: "flex",
                flexDirection: "column",
                width: "20%",
                height: "100%",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "black",
                border: "none",
                color: checkIsSetting
                  ? value === NavBarConst.profile
                    ? "#f5be09"
                    : "white"
                  : checkIsGame
                  ? value === NavBarConst.home
                    ? "#f5be09"
                    : "white"
                  : path === `/setting${value}` || path === `${value}`
                  ? "#f5be09"
                  : "white",
              }}
            >
              <img
                src={toAbsoluteUrl(
                  `/image/${
                    key === "home"
                      ? "games.avif?31234231"
                      : key === "chat"
                      ? "wallet2.avif?7852134"
                      : key === "report"
                      ? "results.avif?15479446"
                      : key === "profile"
                      ? "profile.avif?144573453"
                      : "promotion.avif?13498964783"
                  }`
                )}
                alt={key}
                style={{
                  width: "30px",
                  height: "30px",
                  filter: checkIsSetting
                    ? value === NavBarConst.profile
                      ? "brightness(1.2) sepia(0.5) saturate(5) hue-rotate(5deg)"
                      : "none"
                    : checkIsGame
                    ? value === NavBarConst.home
                      ? "brightness(1.2) sepia(0.5) saturate(5) hue-rotate(5deg)"
                      : "none"
                    : path === `/setting${value}` || path === `${value}`
                    ? "brightness(1.2) sepia(0.5) saturate(5) hue-rotate(5deg)"
                    : "none",
                }}
              />
              <span style={{ fontSize: "10px" }}>
                {intl.formatMessage({ id: key })}
              </span>
            </div>
          ))}
        </div>
        {/* <PromotionReviewModal
          language={language}
          openfrom={"home"}
          ipaddress={ipaddress}
        />

        {sessionStorage.getItem("platform") !== "telegram" && (
          <div
            id="modalTrigger"
            data-bs-toggle="modal"
            data-bs-target="#promotionReviewModal"
            style={{ display: "none" }}
          ></div>
        )} */}

        <div className="rc279-content">
          <Outlet />
        </div>
        {sessionStorage.getItem("platform") !== "telegram" && (
          <div
            className="bottom-download"
            style={{
              height: "50px",
              backgroundColor: "rgb(0,0,0,0.8)",
              position: "fixed",
              bottom: 50,
              width: "100%",
              zIndex: 998,
              display: isVisible ? "flex" : "none",
              alignItems: "center",
              paddingLeft: "5px",
              paddingRight: "5px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <div>
                <img
                  src={imageUrl}
                  alt="Logo"
                  style={{ width: "30px", height: "auto" }}
                />
              </div>
              <div style={{ textAlign: "center", margin: "0 10px" }}>
                <div
                  className="text-font1 ws-nowrap"
                  style={{ display: "flex" }}
                >
                  <div style={{ color: "#f5be09", paddingRight: "5px" }}>
                    279 International
                  </div>
                  <div style={{ color: "#f5be09" }}>
                    <FaStar />
                    <FaStar />
                    <FaStar />
                    <FaStar />
                    <FaStar />
                  </div>
                </div>
                <div
                  className="text-font1 ws-nowrap"
                  style={{ display: "flex" }}
                >
                  <div style={{ color: "white", paddingRight: "5px" }}>
                    Official
                  </div>
                  <div style={{ color: "white", paddingRight: "5px" }}>
                    No Ad
                  </div>
                  <div style={{ color: "white", paddingRight: "5px" }}>
                    No Plugin
                  </div>
                  <div style={{ color: "white" }}>Anti-hijacking</div>
                </div>
              </div>
              <div
                className="text-font2 ws-nowrap"
                style={{
                  border: "1px solid #f5be09",
                  borderRadius: "5px",
                  padding: "5px",
                  color: "#f5be09",
                }}
                onClick={toggleDownload}
              >
                {intl.formatMessage({ id: "downloadapp" })}
              </div>
              <div style={{ color: "white", paddingLeft: "5px" }}>
                <CgCloseO onClick={toggleVisibility} />
              </div>
            </div>
          </div>
        )}
      </MasterLayoutContext.Provider>
    </>
  );
};
